import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Hero from './components/Hero';
import TwinConsole from './components/TwinConsole';

export default function Demo() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="项目演示中心 | 九畴云市数字孪生演示"
        description="九畴云市数字孪生演示中心，支持消费者、云店长、云社员、供应链等七种角色视角切换，直观呈现数字商业全链路。"
        keywords="项目演示,数字孪生,九畴云市,角色视角,数字商业"
        path="/demo"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '项目演示中心',
          description: '九畴云市数字孪生演示中心',
        }}
      />
      <main>
        <Hero />
        <TwinConsole />
      </main>
      <Footer />
    </div>
  );
}